export default "__VITE_ASSET__DPEwUp7m__"